module.exports = __webpack_public_path__ + "img/tomato-3919426.63e63bcb.jpg";